<template>
  <BaseModal
    :show="show"
    :show-close-icon="false"
    @close="close"
  >
    <div class="modal-body mb-4">
      <div class="flex flex-col items-center">
        <header class="text-center pb-4">
          <h3
            class="my-0 font-bold"
            v-text="'Terms of Service'"
          />
        </header>
        <div class="text-center w-full">
          <p>
            Please accept the
            <a
              :href="termsUrl"
              target="_blank"
              rel="noopener noreferrer"
              v-text="'terms of service'"
            />
            to continue using this application.
          </p>
        </div>
        <div class="mb-6">
          <button
            type="button"
            class="btn"
            @click.prevent="acceptTerms"
            v-text="'Accept Terms of Service'"
          />
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script type="text/babel">
export default {
  name: 'AcceptTermsModal',
  data() {
    return {
      localShow: true,
    }
  },
  computed: {
    show() {
      return !this.$root.hasAcceptedTerms && this.localShow
    },
    termsUrl() {
      return `${window.PublicUrl}/terms`
    },
  },
  methods: {
    acceptTerms() {
      this.$api.public().post('terms/accept')
        .then(() => {
          this.$store.commit('baseAddNotification', {
            type: 'success',
            text: 'Terms of service accepted!',
          })
          this.close()
        }).catch(() => {
          this.$store.commit('baseAddNotification', {
            type: 'error',
            text: 'There was a problem accepting the terms of service.',
            timeout: false,
          })
        })
    },
    close() {
      this.localShow = false
    },
  },
}
</script>
